export default __webpack_public_path__ + "static/media/slide6.0b99a796.jpg";